import React from 'react';
import { Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Carlos M.',
  age: 28,
  location: 'Ciudad de México',
  text: 'Dejé de perseguir validación y todo cambió. Ahora las conversaciones fluyen naturalmente.',
  initial: 'C'
}, {
  name: 'Andrés R.',
  age: 24,
  location: 'Bogotá',
  text: 'Por fin entendí por qué siempre terminaba en la friendzone. Este sistema me abrió los ojos.',
  initial: 'A'
}, {
  name: 'Diego L.',
  age: 31,
  location: 'Buenos Aires',
  text: 'Mi seguridad interna cambió completamente. Ya no dependo de la respuesta de nadie.',
  initial: 'D'
}, {
  name: 'Luis P.',
  age: 26,
  location: 'Lima',
  text: 'Ya no me paralizo cuando hablo con alguien que me gusta. Los nervios siguen pero ya no me controlan.',
  initial: 'L'
}, {
  name: 'Miguel S.',
  age: 29,
  location: 'Santiago',
  text: 'El rechazo ya no me destruye. Aprendí que mi valor no depende de un sí o un no.',
  initial: 'M'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-slate-950" data-id="element-220">
      <div className="max-w-7xl mx-auto" data-id="element-221">
        <div className="text-center mb-16" data-id="element-222">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-223">
            Historias de{' '}
            <span className="text-[#FF6B35]" data-id="element-224">Transformación Real</span>
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-225">
            Hombres reales que decidieron tomar el control de su vida amorosa y
            social.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-226">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-slate-900 p-8 rounded-xl border border-slate-800 hover:border-[#FF6B35]/30 transition-all duration-300 hover:-translate-y-1 shadow-lg" data-id="element-227">
              <Quote className="w-10 h-10 text-[#FF6B35]/20 mb-6" data-id="element-228" />
              <p className="text-lg text-slate-200 mb-6 italic leading-relaxed" data-id="element-229">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4" data-id="element-230">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-slate-700 to-slate-800 flex items-center justify-center text-xl font-bold text-[#FF6B35] border border-slate-600" data-id="element-231">
                  {t.initial}
                </div>
                <div data-id="element-232">
                  <h4 className="font-bold text-white" data-id="element-233">
                    {t.name}, {t.age}
                  </h4>
                  <p className="text-sm text-slate-500" data-id="element-234">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}